import { render, staticRenderFns } from "./systemUpdateRecord.vue?vue&type=template&id=86285f88&scoped=true&"
import script from "./systemUpdateRecord.vue?vue&type=script&lang=js&"
export * from "./systemUpdateRecord.vue?vue&type=script&lang=js&"
import style0 from "./systemUpdateRecord.vue?vue&type=style&index=0&id=86285f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86285f88",
  null
  
)

component.options.__file = "systemUpdateRecord.vue"
export default component.exports